/**
 * Configurable row style function for Bootstrap Table.
 * @param {function} classCallback
 * @param {function} cssCallback
 */
window.configureRowStyle = (classCallback = null, cssCallback = null) => {
    if (classCallback === null) classCallback = () => {}
    if (cssCallback === null) cssCallback = () => {}

    return function (row, index)  {
        return {
            classes: classCallback(row, index),
            css: cssCallback(row, index)
        }
    }
}
